export default window.IDEE;
